import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import {
  DatePicker,
  type DatePickerProps
} from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import type { Dayjs } from 'dayjs'
import type { Dispatch, SetStateAction } from 'react'

export type MolsonDatePickerProps = DatePickerProps<Dayjs> & {
  dataTestId?: string
  value: Dayjs | null
  setValue: Dispatch<SetStateAction<Dayjs>>
}

export const MolsonDatePicker = ({
  value,
  setValue,
  dataTestId,
  ...props
}: MolsonDatePickerProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        data-testid={dataTestId}
        value={value}
        onChange={(newValue: Dayjs | null) => newValue && setValue(newValue)}
        format="DD/MM/YYYY"
        {...props}
      />
    </LocalizationProvider>
  )
}
